import PageShell from "./PageShell";
import PremiumGate from "./PremiumGate";
import { Lock } from "lucide-react";
import { usePremium } from "../context/PremiumContext";

// Route-level premium wrapper. Renders the feature when the user is premium,
// otherwise a full page with the upgrade prompt. (On the web isPremium is always
// true, so this only gates inside the Android app.)
export default function PremiumRoute({ feature, perks = [], children }) {
  const { isPremium } = usePremium();
  if (isPremium) return children;
  return (
    <PageShell title={feature} subtitle="A Premium feature" icon={Lock} testid="premium-route-gate">
      <PremiumGate feature={feature} perks={perks} />
    </PageShell>
  );
}
